import React from "react";
import styled, { css } from "styled-components";
import chroma from "chroma-js";
import artiSvg from "assets/arti.svg";
import { Col, Jumbotron, Row } from "components/bootstrap";
import useProductName, { DEFAULT_PRODUCT_NAME } from "brand-customization/useProductName";
const H1 = styled.h1(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.huge};
    margin-bottom: ${theme.spacings.md};
  `
);
const ContainerRow = styled(Row)`
  height: 82vh;
`;
const StyledErrorJumbotron = styled(Jumbotron)(
  ({ theme }) => css`
    background-color: ${chroma(theme.colors.global.contentBackground).alpha(0.8).css()};
    text-align: center;
  `
);
const StyledArti = styled.img`
  height: 10rem;
  float: right;
`;
const Arti = () => /* @__PURE__ */ React.createElement(StyledArti, { src: artiSvg });
const ErrorJumbotron = ({ children, title }) => {
  const productName = useProductName();
  const isDefaultProduct = productName === DEFAULT_PRODUCT_NAME;
  return /* @__PURE__ */ React.createElement(ContainerRow, null, /* @__PURE__ */ React.createElement(Col, { mdOffset: 2, md: 8 }, /* @__PURE__ */ React.createElement(StyledErrorJumbotron, null, isDefaultProduct && /* @__PURE__ */ React.createElement(Arti, null), /* @__PURE__ */ React.createElement(H1, null, title), children)));
};
export default ErrorJumbotron;
